import { Badge, StatusHint } from '@indipia/ui-core'
import { formatReceivedAt } from '@indipia/shared-features'
import type { CustReqReportItem } from '../../types/custReqProgress.types'

// 작업보고 팝업 맨 아래 '고객 요청 반영' — 요청마다 ✓ 반영 / ⚠ 체크 없음. 읽기 전용(941 S16-4).
// 요청이 없으면(필드 없음 포함) 영역을 그리지 않는다.

const caption: React.CSSProperties = { fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }

interface Props {
  items: CustReqReportItem[] | undefined
  /** 같은 날 보고가 여럿일 때 구분용 머리글(예: '10/22 14:30 보고') */
  heading?: string
}

export function ReportCustReqSection({ items, heading }: Props) {
  if (!items || items.length === 0) return null
  const appliedCount = items.filter(r => r.applied).length
  return (
    <section className="mt-3" aria-label="고객 요청 반영">
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className="text-xs font-bold" style={{ color: 'var(--shell-on-surface)' }}>{`고객 요청 반영 ${appliedCount}/${items.length}`}</span>
        {heading && <span style={caption}>{heading}</span>}
      </div>
      <ul className="mt-1.5 flex flex-col gap-2 list-none p-0 m-0">
        {items.map((r, i) => {
          const received = formatReceivedAt(r.receivedAt)
          const meta = [r.srcName, received && `${received} 접수`].filter(Boolean).join(' · ')
          return (
            <li key={r.custReqId} className="rounded-lg p-2" style={{ border: 'var(--border-width-hairline) solid var(--shell-border)' }}>
              <div className="flex items-start gap-1.5">
                <span className="text-sm font-bold" style={{ color: 'var(--shell-on-surface)' }}>{`${i + 1}.`}</span>
                <span className="flex-1 min-w-0 text-sm" style={{ color: 'var(--shell-on-surface)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{r.content}</span>
                {r.applied
                  ? <Badge status="success">✓ 반영</Badge>
                  : <StatusHint tone="warning" icon="⚠">체크 없음</StatusHint>}
              </div>
              {meta && <div className="mt-1" style={caption}>{meta}</div>}
            </li>
          )
        })}
      </ul>
    </section>
  )
}
